import {
  Flex,
  Heading,
  Tab,
  TabContent,
  Tabs,
  TabsList,
} from '@utilitywarehouse/hearth-react';
import {
  CloseSmallIcon,
  TickSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';

import { useSyncState } from '@hooks/useSyncState';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupBhcWhatsNotCoveredClickedOnce } from '@tracking/trackingEvents';

import { ListCovered } from './ListCovered';
import { ListNotCovered } from './ListNotCovered';
import './styles.scss';

const Covered = () => {
  const [isCovered, setIsCovered] = useSyncState('bhc-covered-tab', 'covered');
  const { trackingContexts } = useTrackingContext();
  const trackNotCoveredClickedOnce =
    useTrackSignupBhcWhatsNotCoveredClickedOnce();

  const handleChange = (newValue: string) => {
    setIsCovered(newValue);
  };

  return (
    <Flex spacing="lg" direction="column" asChild>
      <section className="boilerHomeCoverCovered__wrapper">
        <header>
          <Heading className="heading" as="h3" size="lg">
            What's covered?
          </Heading>
        </header>
        <Tabs value={isCovered} onValueChange={handleChange}>
          <TabsList>
            <Tab value="covered">
              <TickSmallIcon /> Covered
            </Tab>
            <Tab
              value="notCovered"
              onClick={() =>
                trackNotCoveredClickedOnce(
                  {},
                  {
                    contexts: trackingContexts,
                  }
                )
              }
            >
              <CloseSmallIcon /> Not covered
            </Tab>
          </TabsList>
          <TabContent value="covered">
            <ListCovered />
          </TabContent>
          <TabContent value="notCovered">
            <ListNotCovered />
          </TabContent>
        </Tabs>
      </section>
    </Flex>
  );
};

export { Covered };
